
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("aYSMh", function(module, exports) {

$parcel$export(module.exports, "DummyConfluenceLinkView", () => $84fea4dbce278f70$export$12af70a3f5929c1e);
/* dummy-confluence-link-view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $k2hpW = parcelRequire("k2hpW");

var $b71gk = parcelRequire("b71gk");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $2gCtH = parcelRequire("2gCtH");

var $f7CQF = parcelRequire("f7CQF");

var $hxqfC = parcelRequire("hxqfC");

var $kQwJI = parcelRequire("kQwJI");

var $iXVV6 = parcelRequire("iXVV6");

var $ldyPw = parcelRequire("ldyPw");

var $g5X3G = parcelRequire("g5X3G");

var $k9JTq = parcelRequire("k9JTq");

var $9OXo1 = parcelRequire("9OXo1");

var $ba9qP = parcelRequire("ba9qP");

var $dIho9 = parcelRequire("dIho9");

var $hBjID = parcelRequire("hBjID");

var $1XnrJ = parcelRequire("1XnrJ");

var $7PZLB = parcelRequire("7PZLB");

var $g5LTL = parcelRequire("g5LTL");

var $kRpPw = parcelRequire("kRpPw");

var $h7Cad = parcelRequire("h7Cad");

var $kFa3X = parcelRequire("kFa3X");

var $5E5Kv = parcelRequire("5E5Kv");

var $c6paD = parcelRequire("c6paD");

var $d8jOU = parcelRequire("d8jOU");

var $cWVyo = parcelRequire("cWVyo");

var $3K0KG = parcelRequire("3K0KG");

var $lD0gw = parcelRequire("lD0gw");

var $3sqIb = parcelRequire("3sqIb");

var $j1hWq = parcelRequire("j1hWq");
const $84fea4dbce278f70$export$ba32f287c35f26 = ({ issueType: issueType, tenantHasConfluenceAppLinks: tenantHasConfluenceAppLinks, projectName: projectName, projectId: projectId, onLinkPage: onLinkPage })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const template = (0, $5uXOq.useMemo)(()=>(0, $7PZLB.getConfluencePlaceholderTemplate)(issueType), [
        issueType
    ]);
    const crossFlow = (0, $k2hpW.useCrossFlow)();
    const issueKey = (0, $2gCtH.useIssueKey)();
    const appEditions = (0, $k9JTq.useAppEditions)();
    const { isDismissed: isDismissed, onDismissAd: onDismissAd } = (0, $ba9qP.useAdControlsFunctionality)({
        userPropertyPlaceholderTemplate: (0, $hBjID.USER_PROPERTY_DUMMY_LINK)
    });
    const { isCrossFlowEligible: isCrossFlowEligible } = (0, $1XnrJ.useIsCrossFlowEligible)();
    const isCrossFlowEnabled = isCrossFlowEligible && !tenantHasConfluenceAppLinks;
    const { areProductSuggestionsEnabled: areProductSuggestionsEnabled, cloudId: cloudId } = (0, $9OXo1.useTenantContext)(); // Only show dummy link to Free, Standard and Premium sites
    const showDummyLink = areProductSuggestionsEnabled && !!template && isCrossFlowEnabled && !isDismissed && (appEditions.software === (0, $ldyPw.FREE_EDITION) || appEditions.software === (0, $ldyPw.STANDARD_EDITION) || appEditions.software === (0, $ldyPw.PREMIUM_EDITION));
    const { canProvisionConfluence: canProvisionConfluence, fetchStatus: fetchStatus } = (0, $h7Cad.useUserHasAddProductPermissions)({
        embeddedConfluenceSource: 'jswIssueView',
        skip: !showDummyLink // Skip permission check if these experiences are disabled
    });
    const { fireViewedEvent: fireViewedEvent, fireClickedEvent: fireClickedEvent } = (0, $7PZLB.useFireCrossFlowAnalyticsEvents)(canProvisionConfluence);
    const epModalEntryPointContainer = (0, $kRpPw.useDraftEpModal)({
        ...(0, $4R6GH.fg)('jira_issue_view_expand_modeless_ep') && {
            linkConfluencePage: onLinkPage
        }
    });
    const { isEpModalOpen: isEpModalOpen, setIsEpModalOpen: setIsEpModalOpen, setActivePageUrl: setActivePageUrl } = (0, $g5LTL.useConfluenceDummyLinkContext)();
    const tenantIsOnFreeEdition = appEditions.software === (0, $ldyPw.FREE_EDITION);
    (0, $5uXOq.useEffect)(()=>{
        if (showDummyLink && fetchStatus !== 'pending') fireViewedEvent();
    }, [
        showDummyLink,
        fireViewedEvent,
        fetchStatus
    ]);
    // upon successful crossflow, the window is reloaded with href should have spaceKey as a query param
    const initializeDraftAndOpenModal = (0, $5uXOq.useCallback)(async ()=>{
        const spaceKey = (0, $7PZLB.getSpaceKeyAndUpdateUrl)();
        if (!spaceKey || !template) return;
        const result = await (0, $5E5Kv.createConfluenceDraft)(cloudId, spaceKey, template.blueprintModuleCompleteKey);
        if (result) {
            const activePageUrl = (0, $c6paD.getActivePageUrl)(result.contentId, result.draftShareId, spaceKey);
            setActivePageUrl(activePageUrl);
            setIsEpModalOpen(true);
        }
    }, [
        cloudId,
        setActivePageUrl,
        setIsEpModalOpen,
        template
    ]);
    (0, $5uXOq.useEffect)(()=>{
        initializeDraftAndOpenModal();
    }, [
        initializeDraftAndOpenModal
    ]);
    const [requestStatusLozengeText, recomputeHasRequestedTrialState] = (0, $kFa3X.useHasRequestedTrialLozengeText)();
    const issueViewEndUsersCrossFlowViaE2EExp = (0, $lD0gw.useIssueViewEndUsersCrossFlowViaE2EExperiment)();
    const jswIssueLink = typeof window !== 'undefined' ? `${window.location.origin}/browse/${issueKey}` : undefined; // exposure for new experiment is on the onClick
    const onClickConfluencePlaceholder = (0, $5uXOq.useCallback)(async (e)=>{
        // prevents page from reloading
        e.preventDefault();
        if (canProvisionConfluence) {
            fireClickedEvent('confluencePlaceholderTemplateLink', 'placeholderTemplateE2EIteration');
            const experimentalOptions = {
                jswIssueType: template && template.suggestedIssueType,
                projectName: projectName || '',
                jswIssueLink: jswIssueLink
            };
            await (0, $7PZLB.openCffeForConfluence)(crossFlow, 'confluencePlaceholderTemplateScreen', 'confluencePlaceholderTemplateLink', experimentalOptions);
        } else if (!canProvisionConfluence && !tenantIsOnFreeEdition) {
            fireClickedEvent('confluencePlaceholderTemplateLink', 'placeholderTemplateEndUserRequestExperiment');
            await (0, $7PZLB.openCffeForConfluence)(crossFlow, 'confluencePlaceholderTemplateScreen', 'confluencePlaceholderTemplateLink', {
                placeholderTemplateEndUserRequestExperiment: true
            });
            recomputeHasRequestedTrialState();
        } else if (issueViewEndUsersCrossFlowViaE2EExp.experimentIsEnabled && issueViewEndUsersCrossFlowViaE2EExp.isEnrolledInExperiment()) {
            issueViewEndUsersCrossFlowViaE2EExp.fireExposureEvent();
            if (issueViewEndUsersCrossFlowViaE2EExp.isVariation()) {
                fireClickedEvent('confluencePlaceholderTemplateLink', 'issueViewEndUsersCrossFlowViaE2EExperiment');
                const experimentalOptions = {
                    jswIssueType: template && template.suggestedIssueType,
                    projectName: projectName || '',
                    jswIssueLink: jswIssueLink
                };
                await (0, $7PZLB.openCffeForConfluence)(crossFlow, 'confluencePlaceholderTemplateScreen', 'placeholderTemplateEndUsersCrossFlowViaE2EFlow', experimentalOptions);
            } else // This component only renders when there is a template, so it is available
            // This window check is not part of the SSR hyrdation
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, jira/jira-ssr/no-unchecked-globals-usage
            window.open(template.url, '_blank');
        } else {
            fireClickedEvent('confluencePlaceholderTemplateLink', 'placeholderTemplateContextual'); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            template && window.open(template.url, '_blank');
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        fireClickedEvent,
        jswIssueLink
    ]);
    if (isEpModalOpen) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, epModalEntryPointContainer);
    if (!showDummyLink) return null;
    const renderHeading = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3sqIb.DummySectionHeading), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3sqIb.DummySectionHeading), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f7CQF.SectionHeadingTitle), null, formatMessage((0, $3K0KG.default).newHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
            sourceName: "descriptionTemplatesInfoDialog",
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j1hWq.InfoIconWithPopup), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIho9.default), {
            onClickDismiss: onDismissAd
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, renderHeading(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d8jOU.ConfluenceLink), {
        canProvisionConfluence: canProvisionConfluence,
        tenantIsOnFreeEdition: tenantIsOnFreeEdition,
        onClickPlaceholderTemplate: onClickConfluencePlaceholder,
        template: template,
        showDummyLink: showDummyLink,
        projectName: projectName,
        requestStatusLozengeText: requestStatusLozengeText
    }), (0, $4R6GH.fg)('placeholder-template-background-provisioning-gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "confluence-content-placeholder.background-provisioning-editor",
        packageName: "@atlassian/jira-issue-view-base/confluence-dummy-link/background-provisioning-editor",
        render: ()=>null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cWVyo.BackgroundProvisioningEditor), {
        issueType: issueType?.name?.toLowerCase?.(),
        cloudId: cloudId,
        projectId: projectId
    })));
};
const $84fea4dbce278f70$var$mapDispatchToProps = (dispatch)=>({
        onLinkPage: (link, analyticsEvent)=>dispatch((0, $kQwJI.createConfluencePageLinkRequest)((0, $g5X3G.toHref)(link), analyticsEvent))
    });
const $84fea4dbce278f70$var$mapStateToProps = ()=>({});
const $84fea4dbce278f70$var$DummyConfluenceLinkViewWithReduxDispatchProps = (0, $hxqfC.connect)($84fea4dbce278f70$var$mapStateToProps, $84fea4dbce278f70$var$mapDispatchToProps)($84fea4dbce278f70$export$ba32f287c35f26);
const $84fea4dbce278f70$export$12af70a3f5929c1e = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('jira_issue_view_expand_modeless_ep'), $84fea4dbce278f70$var$DummyConfluenceLinkViewWithReduxDispatchProps, $84fea4dbce278f70$export$ba32f287c35f26);

});
// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("ba9qP", function(module, exports) {

$parcel$export(module.exports, "useAdControlsFunctionality", () => $f93db2d9bd9d155e$export$200d7892ced015e6);

var $5uXOq = parcelRequire("5uXOq");

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");

var $8zOmE = parcelRequire("8zOmE");
var $d22NM = parcelRequire("d22NM");

var $90yGq = parcelRequire("90yGq");

var $7PZLB = parcelRequire("7PZLB");
const $f93db2d9bd9d155e$var$AD_CONTROLS_FETCH_ERROR = 'adControlsFetchError';
const $f93db2d9bd9d155e$export$200d7892ced015e6 = ({ userPropertyPlaceholderTemplate: userPropertyPlaceholderTemplate })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $d22NM.useAnalyticsEvents)();
    const accountId = (0, $90yGq.useAccountId)() || '';
    const [isDismissed, setIsDismissed] = (0, $5uXOq.useState)(true);
    const fetchUserProperties = (0, $5uXOq.useCallback)(async ()=>{
        try {
            const res = await (0, $7PZLB.getHasDismissedConfluencePlaceholderTemplate)(accountId, userPropertyPlaceholderTemplate);
            setIsDismissed(!!res);
        } catch (error) {
            setIsDismissed(true);
            let adControlsError;
            if (error instanceof (0, $jJZqs.default)) adControlsError = new Error(`Fetch Error, failed to get user property: ${userPropertyPlaceholderTemplate}, status code was: ${error.statusCode}`);
            else adControlsError = new Error(`Failed to get user property: ${userPropertyPlaceholderTemplate}`, {
                cause: error
            });
            (0, $jcw0u.default)({
                meta: {
                    id: $f93db2d9bd9d155e$var$AD_CONTROLS_FETCH_ERROR,
                    packageName: 'jiraIssueViewBase',
                    teamName: 'starburst'
                },
                error: adControlsError
            });
        }
    }, [
        accountId,
        userPropertyPlaceholderTemplate
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (accountId !== '') fetchUserProperties();
    }, [
        accountId,
        fetchUserProperties
    ]);
    const clickedButtonBaseEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'button'
    });
    const onDismissAd = (0, $5uXOq.useCallback)(async ()=>{
        await (0, $89SaW.setUserProperties)(accountId, userPropertyPlaceholderTemplate, JSON.stringify(true));
        setIsDismissed(true);
        (0, $8zOmE.fireUIAnalytics)(clickedButtonBaseEvent, 'notInterested', {
            panelName: 'crossflow-confluence-placeholder-template'
        });
    }, [
        accountId,
        userPropertyPlaceholderTemplate,
        clickedButtonBaseEvent
    ]);
    return {
        isDismissed: isDismissed,
        onDismissAd: onDismissAd
    };
};

});

parcelRegister("dIho9", function(module, exports) {

$parcel$export(module.exports, "default", () => $312f32976491e469$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $duIk1 = parcelRequire("duIk1");

var $kfIGo = parcelRequire("kfIGo");

var $flvYJ = parcelRequire("flvYJ");

var $hCfTW = parcelRequire("hCfTW");

var $8cc7O = parcelRequire("8cc7O");
var $ZY1kc = parcelRequire("ZY1kc");
var $i79po = parcelRequire("i79po");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");

var $jCTxx = parcelRequire("jCTxx");

var $4D4Ym = parcelRequire("4D4Ym");
const $312f32976491e469$var$AdControls = ({ onClickDismiss: onClickDismiss, menuButtonTestId: menuButtonTestId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8cc7O.default), {
        itemId: "placeholder-template-ad-controls",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCfTW.default), {
                paddingInline: "space.050"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $duIk1.default), {
                ...props,
                testId: menuButtonTestId,
                appearance: "subtle",
                spacing: "compact",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($flvYJ))), {
                    color: "currentColor",
                    label: "more",
                    spacing: "none",
                    LEGACY_size: "small"
                }),
                ref: triggerRef,
                interactionName: "auto-generated.jira-issue-view-base.content.confluence-placeholder-template-experiment.common.ad-controls.button"
            }))
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ZY1kc.default), {
            ...props,
            flagProps: {
                title: formatMessage((0, $jCTxx.default).dismissFlagTitle),
                description: formatMessage((0, $jCTxx.default).dismissFlagDescription)
            },
            onClick: onClickDismiss
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i79po.default), {
            ...props,
            modalProps: {
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kfIGo.default), {
                    size: "medium"
                }, formatMessage((0, $jCTxx.default).reasonsModalTitle)),
                body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
                    sourceName: "adControlsReasons",
                    sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4D4Ym.default), null))
            }
        })));
};
var $312f32976491e469$export$2e2bcd8739ae039 = $312f32976491e469$var$AdControls;

});
parcelRegister("4D4Ym", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed7bdc606e4ceff0$export$2e2bcd8739ae039);
/* reasons-modal.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $duIk1 = parcelRequire("duIk1");

var $1lQB4 = parcelRequire("1lQB4");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $d22NM = parcelRequire("d22NM");

var $hBjID = parcelRequire("hBjID");

var $jCTxx = parcelRequire("jCTxx");
const $ed7bdc606e4ceff0$var$AdControlsReasonsModal = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $d22NM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    (0, $5uXOq.useEffect)(()=>{
        (0, $8zOmE.fireScreenAnalytics)(createAnalyticsEvent({}));
    }, [
        createAnalyticsEvent
    ]);
    const clickedLinkBaseEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'link'
    });
    const onClickPrivacyPolicy = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(clickedLinkBaseEvent, 'adControlsPrivacyPolicy');
    }, [
        clickedLinkBaseEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, $jCTxx.default).reasonsModalExplanation, {
        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1lQB4.default), {
                as: "strong"
            }, chunks)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed7bdc606e4ceff0$var$BulletPoints, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", null, formatMessage((0, $jCTxx.default).reasonsModalBulletOne)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", null, formatMessage((0, $jCTxx.default).reasonsModalBulletTwo))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $duIk1.default), {
        appearance: "link",
        spacing: "none",
        href: (0, $hBjID.DATA_PRIVACY_LINK),
        target: "_blank",
        onClick: onClickPrivacyPolicy,
        interactionName: "auto-generated.jira-issue-view-base.content.confluence-placeholder-template-experiment.common.ad-controls.button"
    }, formatMessage((0, $jCTxx.default).privacyPolicy)));
};
var $ed7bdc606e4ceff0$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $ed7bdc606e4ceff0$var$AdControlsReasonsModal;
const $ed7bdc606e4ceff0$var$BulletPoints = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyrutpp",
            __cmplp.className
        ])
    });
});

});


parcelRegister("1XnrJ", function(module, exports) {

$parcel$export(module.exports, "useIsCrossFlowEligible", () => $71ad2e620ab4aa58$export$ff76dd1cdd043d2b);

var $fBBgV = parcelRequire("fBBgV");

var $9OXo1 = parcelRequire("9OXo1");
const $71ad2e620ab4aa58$export$ff76dd1cdd043d2b = ()=>{
    const { licensedProducts: licensedProducts } = (0, $9OXo1.useTenantContext)();
    const crossFlow = (0, $fBBgV.useCrossFlow)();
    const tenantHasConfluence = licensedProducts?.confluence === true;
    const isCrossFlowEligible = !tenantHasConfluence && crossFlow.isEnabled;
    return {
        isCrossFlowEligible: isCrossFlowEligible
    };
};

});

parcelRegister("kRpPw", function(module, exports) {

$parcel$export(module.exports, "useDraftEpModal", () => $c0ca9159faa1894a$export$d47a07158f47da);

var $g5LTL = parcelRequire("g5LTL");

var $4vCny = parcelRequire("4vCny");
const $c0ca9159faa1894a$export$d47a07158f47da = ({ onEmbeddedContentAction: onEmbeddedContentAction, onPublish: onPublish, linkConfluencePage: linkConfluencePage })=>{
    const { isEpModalOpen: isEpModalOpen, activePageUrl: activePageUrl, setIsEpModalOpen: setIsEpModalOpen, setIsLoading: setIsLoading } = (0, $g5LTL.useConfluenceDummyLinkContext)();
    const { epModalEntryPointContainer: epModalEntryPointContainer } = (0, $4vCny.useDraftEmbeddedPageModalEntryPoint)({
        isEpModalOpen: isEpModalOpen,
        setIsEpModalOpen: setIsEpModalOpen,
        activePageUrl: activePageUrl,
        embeddedConfluenceSource: 'jswIssueView',
        onEmbeddedContentAction: onEmbeddedContentAction,
        onPublish: onPublish,
        setIsLoading: setIsLoading,
        linkConfluencePage: linkConfluencePage
    });
    return epModalEntryPointContainer;
};

});
parcelRegister("4vCny", function(module, exports) {

$parcel$export(module.exports, "useDraftEmbeddedPageModalEntryPoint", () => $3509afe14e06bec7$export$d575cf302237c037);

var $5uXOq = parcelRequire("5uXOq");

var $50LfS = parcelRequire("50LfS");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $4R6GH = parcelRequire("4R6GH");

var $fvjUj = parcelRequire("fvjUj");

var $dELl0 = parcelRequire("dELl0");
const $3509afe14e06bec7$export$d575cf302237c037 = ({ isEpModalOpen: isEpModalOpen, activePageUrl: activePageUrl, setIsEpModalOpen: setIsEpModalOpen, embeddedConfluenceSource: embeddedConfluenceSource, onEmbeddedContentAction: onEmbeddedContentAction, onPublish: onPublish, setIsLoading: setIsLoading, linkConfluencePage: linkConfluencePage })=>{
    const parentProduct = (0, $fvjUj.useParentProduct)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $dELl0.draftEmbeddedPageModalEntrypoint), {});
    const onClose = (0, $5uXOq.useCallback)(()=>{
        setIsLoading(false);
        setIsEpModalOpen(false);
        entryPointActions.unload();
    }, [
        setIsEpModalOpen,
        entryPointActions,
        setIsLoading
    ]);
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            ...(0, $4R6GH.fg)('jira_issue_view_expand_modeless_ep') && {
                linkConfluencePage: linkConfluencePage
            },
            hasFooterLogo: false,
            isOpen: true,
            onClose: onClose,
            parentProduct: parentProduct,
            url: activePageUrl,
            embeddedConfluenceSource: embeddedConfluenceSource,
            spaceKey: (0, $50LfS.parseUrl)(activePageUrl)?.spaceKey,
            contentId: (0, $50LfS.parseUrl)(activePageUrl)?.contentId,
            onPageAction: onEmbeddedContentAction,
            allowedFeatures: {
                view: [
                    'byline-contributors',
                    'byline-extensions',
                    'page-comments',
                    'page-reactions',
                    'inline-comments',
                    'non-licensed-share'
                ]
            },
            onPublish: onPublish
        }), [
        onClose,
        parentProduct,
        activePageUrl,
        embeddedConfluenceSource,
        onEmbeddedContentAction,
        onPublish,
        linkConfluencePage
    ]);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (isEpModalOpen) entryPointActions.load();
    }, [
        isEpModalOpen,
        entryPointActions
    ]);
    return {
        epModalEntryPointContainer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "epModalEntrypointContainer",
            packageName: "jiraIssueViewBase",
            teamName: "starburst",
            runtimeProps: runtimeProps
        })
    };
};

});


parcelRegister("h7Cad", function(module, exports) {

$parcel$export(module.exports, "useUserHasAddProductPermissions", () => $e8be6087aa04ab03$export$d223ceb381c5cc91);

var $5uXOq = parcelRequire("5uXOq");

var $7gmqg = parcelRequire("7gmqg");

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");

var $4TSh0 = parcelRequire("4TSh0");

var $cNd4s = parcelRequire("cNd4s");

var $9OXo1 = parcelRequire("9OXo1");
const $e8be6087aa04ab03$var$USER_ADD_PRODUCT_PERMISSION = 'userAddProductPermission';
const $e8be6087aa04ab03$export$dce989a46ba6d54c = async (cloudId)=>{
    const response = await (0, $7f4tk.default)('/gateway/api/permissions/permitted', {
        method: 'POST',
        body: JSON.stringify({
            resourceId: (0, $7gmqg.PlatformSiteAri).create({
                siteId: cloudId
            }).toString(),
            permissionId: 'add-products'
        }),
        headers: {
            Accept: 'application/json'
        }
    });
    return response;
};
const $e8be6087aa04ab03$export$d223ceb381c5cc91 = ({ embeddedConfluenceSource: embeddedConfluenceSource, skip: skip = false })=>{
    const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const [status, setStatus] = (0, $5uXOq.useState)({
        canProvisionConfluence: false,
        fetchStatus: 'pending'
    });
    const fireAnalyticsEvent = (0, $4TSh0.useEmbeddedPageTracking)();
    (0, $5uXOq.useEffect)(()=>{
        if (skip) return;
        if (isSiteAdmin) {
            // Shortcut - Site admins have add-product permissions
            setStatus({
                canProvisionConfluence: true,
                fetchStatus: 'resolved'
            });
            return;
        }
        const getAddProductPermissions = async ()=>{
            try {
                const response = await $e8be6087aa04ab03$export$dce989a46ba6d54c(cloudId);
                setStatus({
                    canProvisionConfluence: response?.permitted,
                    fetchStatus: 'resolved'
                });
                fireAnalyticsEvent({
                    action: 'success',
                    eventName: $e8be6087aa04ab03$var$USER_ADD_PRODUCT_PERMISSION,
                    embeddedConfluenceSource: embeddedConfluenceSource
                });
            } catch (error) {
                setStatus({
                    canProvisionConfluence: false,
                    fetchStatus: 'failed'
                });
                (0, $jcw0u.default)({
                    meta: {
                        id: $e8be6087aa04ab03$var$USER_ADD_PRODUCT_PERMISSION,
                        packageName: 'jiraIssueViewBase',
                        teamName: 'starburst'
                    },
                    attributes: {
                        embeddedConfluenceSource: embeddedConfluenceSource
                    },
                    error: new Error(`Failed to get ${$e8be6087aa04ab03$var$USER_ADD_PRODUCT_PERMISSION} status: ${error}`)
                });
            }
        };
        getAddProductPermissions();
    }, [
        cloudId,
        embeddedConfluenceSource,
        fireAnalyticsEvent,
        isSiteAdmin,
        skip
    ]);
    return status;
};

});
parcelRegister("7gmqg", function(module, exports) {

$parcel$export(module.exports, "PlatformSiteAri", () => $549b6bac78d37a28$export$62388e9e87e2e1c9);

var $fgUxA = parcelRequire("fgUxA");

var $9KGzW = parcelRequire("9KGzW");

var $1C2Ux = parcelRequire("1C2Ux");
// src/platform/site/manifest.ts
var $549b6bac78d37a28$var$platformSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $fgUxA.PlatformSiteAriResourceOwner),
    resourceType: (0, $fgUxA.PlatformSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/platform/site/index.ts
var $549b6bac78d37a28$export$62388e9e87e2e1c9 = class _PlatformSiteAri extends (0, $9KGzW.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.resourceIdSegmentValues.siteId;
    }
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $549b6bac78d37a28$var$platformSiteAriStaticOpts.qualifier,
            platformQualifier: $549b6bac78d37a28$var$platformSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $549b6bac78d37a28$var$platformSiteAriStaticOpts.resourceOwner,
            resourceType: $549b6bac78d37a28$var$platformSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $1C2Ux.AriParser).fromOpts(derivedOpts, $549b6bac78d37a28$var$platformSiteAriStaticOpts);
        return new _PlatformSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $1C2Ux.AriParser).fromString(maybeAri, $549b6bac78d37a28$var$platformSiteAriStaticOpts);
        return new _PlatformSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
};

});
parcelRegister("fgUxA", function(module, exports) {

$parcel$export(module.exports, "PlatformSiteAriResourceOwner", () => $b1e4357700847247$export$2866935ccba4694c);
$parcel$export(module.exports, "PlatformSiteAriResourceType", () => $b1e4357700847247$export$c9ae8b227ea4b550);
// src/platform/site/types.ts
var $b1e4357700847247$export$2866935ccba4694c = "platform", $b1e4357700847247$export$c9ae8b227ea4b550 = "site";

});



parcelRegister("kFa3X", function(module, exports) {

$parcel$export(module.exports, "useHasRequestedTrialLozengeText", () => $596e8055a088c815$export$488b640374e1a470);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $9OXo1 = parcelRequire("9OXo1");

var $6Kng1 = parcelRequire("6Kng1");

var $3K0KG = parcelRequire("3K0KG");
const $596e8055a088c815$export$488b640374e1a470 = ()=>{
    const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [hasRequestedTrial, setHasRequestedTrial] = (0, $5uXOq.useState)(()=>(0, $6Kng1.hasLocalStorageRequestedTrial)(cloudId));
    const computeLozengeText = ()=>hasRequestedTrial ? formatMessage((0, $3K0KG.default).requestSentLozenge) : formatMessage((0, $3K0KG.default).requestToTryLozenge);
    const recomputeHasRequestedTrialLozengeText = ()=>{
        setHasRequestedTrial((0, $6Kng1.hasLocalStorageRequestedTrial)(cloudId));
    };
    // Memoize the lozenge text to avoid unnecessary computations on each render.
    // This will only recompute when hasRequestedTrial changes.
    const requestStatusLozengeText = (0, $5uXOq.useMemo)(()=>computeLozengeText(), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        hasRequestedTrial,
        formatMessage
    ]);
    return [
        requestStatusLozengeText,
        recomputeHasRequestedTrialLozengeText
    ];
};

});

parcelRegister("5E5Kv", function(module, exports) {

$parcel$export(module.exports, "createConfluenceDraft", () => $def0f63aa9c7ee85$export$35a28ef15d43eade);

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");

var $eIwq1 = parcelRequire("eIwq1");
const $def0f63aa9c7ee85$export$35a28ef15d43eade = async (cloudId, spaceKey, blueprintModuleCompleteKey)=>{
    try {
        const [blueprint] = await Promise.all([
            (0, $eIwq1.getBlueprint)(cloudId, spaceKey, blueprintModuleCompleteKey)
        ]);
        const response = await (0, $7f4tk.default)(`/gateway/api/ex/confluence/${cloudId}/wiki/rest/create-dialog/1.0/content/blueprint/${blueprintModuleCompleteKey}/instance`, {
            method: 'POST',
            body: JSON.stringify({
                content: {
                    type: 'page',
                    status: 'draft',
                    space: {
                        key: spaceKey
                    },
                    metadata: {
                        properties: {
                            editor: {
                                value: 'v2'
                            }
                        },
                        frontend: {
                            embedded: true
                        }
                    }
                },
                contentBlueprintSpec: {
                    context: {
                        spaceKey: spaceKey
                    },
                    blueprintId: blueprint.contentBlueprintId
                }
            })
        });
        return {
            contentId: response.content.id,
            draftShareId: response.content._links.editui?.match(/draftShareId=(.*?)(#|&|$)/)?.[1]
        };
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'createConfluenceDraft',
                packageName: 'jiraIssueViewBase',
                teamName: 'starburst'
            },
            error: {
                name: 'error',
                message: `Fetching blueprints succeeded, but blueprint: ${blueprintModuleCompleteKey} was not found for space: ${spaceKey}`
            }
        });
        return null;
    }
};

});
parcelRegister("eIwq1", function(module, exports) {

$parcel$export(module.exports, "getBlueprint", () => $88fbe32b6bbe4062$export$ebbc6f9d15c71fb0);

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");
const $88fbe32b6bbe4062$export$ebbc6f9d15c71fb0 = async (cloudId, spaceKey, blueprintModuleCompleteKey)=>{
    let blueprints;
    const url = `/gateway/api/ex/confluence/${cloudId}/wiki/rest/create-dialog/1.0/blueprints/web-items?spaceKey=${spaceKey}`;
    try {
        blueprints = await (0, $7f4tk.default)(url);
        const found = blueprints.find((blueprint)=>blueprint.blueprintModuleCompleteKey === blueprintModuleCompleteKey);
        if (!found) throw new Error(`Fetching blueprints succeeded, but blueprint: ${blueprintModuleCompleteKey} was not found for space: ${spaceKey}`);
        return found;
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'createConfluenceDraftGetBlueprint',
                packageName: 'jiraIssueViewBase',
                teamName: 'starburst'
            },
            error: {
                name: 'error',
                message: `Unknown error calling getBlueprint for space: ${spaceKey}`
            }
        });
        throw error || new Error(`Error calling ${url}`);
    }
};

});


parcelRegister("c6paD", function(module, exports) {

$parcel$export(module.exports, "getActivePageUrl", () => $7b74ce3b2ea8af8e$export$9c15ab9e1732ad28);
const $7b74ce3b2ea8af8e$export$9c15ab9e1732ad28 = (contentId, draftShareId, spaceKey)=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    `${window.location.origin}/wiki/spaces/${spaceKey}/pages/edit-v2/${contentId}/?draftShareId=${draftShareId}`;

});

parcelRegister("d8jOU", function(module, exports) {

$parcel$export(module.exports, "ConfluenceLink", () => $107430e48d726a0b$export$b7e5de785951c470);

var $5uXOq = parcelRequire("5uXOq");

var $ciPDq = parcelRequire("ciPDq");

var $4OZ6V = parcelRequire("4OZ6V");

var $3sqIb = parcelRequire("3sqIb");
function $107430e48d726a0b$export$b7e5de785951c470({ canProvisionConfluence: canProvisionConfluence, tenantIsOnFreeEdition: tenantIsOnFreeEdition, onClickPlaceholderTemplate: onClickPlaceholderTemplate, template: template, requestStatusLozengeText: requestStatusLozengeText }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3sqIb.DummyGroupContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ciPDq.Container), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4OZ6V.DummyConfluenceEntryPoint), {
        templateName: template.name,
        canProvisionConfluence: canProvisionConfluence,
        onClick: onClickPlaceholderTemplate,
        tenantIsOnFreeEdition: tenantIsOnFreeEdition,
        requestStatusLozengeText: requestStatusLozengeText
    })));
}

});
parcelRegister("4OZ6V", function(module, exports) {

$parcel$export(module.exports, "DummyConfluenceEntryPoint", () => $cf1d893daae40304$export$8af9cb3e83336acc);

var $5uXOq = parcelRequire("5uXOq");

var $2snjz = parcelRequire("2snjz");

var $85YxZ = parcelRequire("85YxZ");

var $bTT6v = parcelRequire("bTT6v");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $3K0KG = parcelRequire("3K0KG");

var $3sqIb = parcelRequire("3sqIb");
const $cf1d893daae40304$export$8af9cb3e83336acc = ({ templateName: templateName, requestStatusLozengeText: requestStatusLozengeText, tenantIsOnFreeEdition: tenantIsOnFreeEdition, canProvisionConfluence: canProvisionConfluence, onClick: onClick, onClickCapture: onClickCapture })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3sqIb.StyledLink), {
        onClick: onClick,
        onClickCapture: onClickCapture,
        "data-testid": "issue-view-base.content.confluence-placeholder-template-experiment.confluence-dummy-link.styled-link"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3sqIb.CardWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3sqIb.LeftWrapper), null, (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2snjz.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bTT6v))),
        label: "",
        appearance: "blueBold",
        shape: "square",
        size: "16"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $85YxZ.default), {
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3sqIb.StyledTemplateName), null, formatMessage(templateName))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3sqIb.RightWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3sqIb.TryLozenge), {
        appearance: "new"
    }, tenantIsOnFreeEdition || canProvisionConfluence ? formatMessage((0, $3K0KG.default).tryTemplateLozenge) : requestStatusLozengeText))));
};

});
parcelRegister("3sqIb", function(module, exports) {

$parcel$export(module.exports, "DummySectionHeading", () => $1ed92604df5e6e84$export$1c684df08303aef9);
$parcel$export(module.exports, "InfoButton", () => $1ed92604df5e6e84$export$10d4b9c1046c21df);
$parcel$export(module.exports, "TryLozenge", () => $1ed92604df5e6e84$export$ff5672c4664546a);
$parcel$export(module.exports, "StyledLink", () => $1ed92604df5e6e84$export$9048d548939551ee);
$parcel$export(module.exports, "RightWrapper", () => $1ed92604df5e6e84$export$8e62e599821d99ec);
$parcel$export(module.exports, "LeftWrapper", () => $1ed92604df5e6e84$export$c3d2343a748f64d3);
$parcel$export(module.exports, "DummyGroupContainer", () => $1ed92604df5e6e84$export$8959dc0d4392a216);
$parcel$export(module.exports, "CardWrapper", () => $1ed92604df5e6e84$export$6aa22a823032b784);
$parcel$export(module.exports, "StyledTemplateName", () => $1ed92604df5e6e84$export$c76ce79facc3b67b);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $duIk1 = parcelRequire("duIk1");

var $eiJsc = parcelRequire("eiJsc");

var $41j30 = parcelRequire("41j30");

var $hjSnd = parcelRequire("hjSnd");
const $1ed92604df5e6e84$export$1c684df08303aef9 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $hjSnd.FieldHeadingIconsVisibility), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulph8dc _1e0c1txw _4cvr1h6o _1n261q9c _1bah1yb4",
            __cmplp.className
        ])
    });
});
const $1ed92604df5e6e84$export$10d4b9c1046c21df = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $duIk1.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_vwz41tcg _1bsb1tcg _4t3i1tcg",
            __cmplp.className
        ])
    });
});
const $1ed92604df5e6e84$export$ff5672c4664546a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $eiJsc.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u01b66",
            __cmplp.className
        ])
    });
});
const $1ed92604df5e6e84$export$9048d548939551ee = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $41j30.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4bfu18uv _1hmsglyw _ajmmnqa1 _1nrm18uv _1a3b18uv _9oik18uv _5bd618uv _1ydc18uv _c2waglyw _4fprglyw _1bnxglyw _13jxglyw _1x28glyw _1iohnqa1 _5goinqa1 _jf4cnqa1 _xatrnqa1 _1726nqa1",
            __cmplp.className
        ])
    });
});
const $1ed92604df5e6e84$export$8e62e599821d99ec = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulph8dc _1e0c1txw _4cvr1h6o _1bah1yb4 _syaz1fxt",
            __cmplp.className
        ])
    });
});
const $1ed92604df5e6e84$export$c3d2343a748f64d3 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulph8dc _1e0c1txw _4cvr1h6o _1bah1yb4 _syaz1fxt _1ul9idpf",
            __cmplp.className
        ])
    });
});
const $1ed92604df5e6e84$export$8959dc0d4392a216 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pku2gc _2hwxidpf _otyru2gc _18u0idpf _u5f3v77o",
            __cmplp.className
        ])
    });
});
const $1ed92604df5e6e84$export$6aa22a823032b784 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _n7zlzgxb _16qsglyw _bfhk1w7a _ca0qidpf _u5f312x7 _n3tdidpf _19bv12x7 _19pkidpf _2hwxv77o _otyridpf _18u0v77o _1e0c1txw _1tke1ylp _1bah1yb4 _4cvr1h6o _1wpz1fhb _y7iw3acm _9oik18uv _1bnxglyw _jf4cnqa1 _irr3166n _d0altlke",
            __cmplp.className
        ])
    });
});
const $1ed92604df5e6e84$export$c76ce79facc3b67b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _19pkze3t _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});

});



parcelRegister("lD0gw", function(module, exports) {

$parcel$export(module.exports, "useIssueViewEndUsersCrossFlowViaE2EExperiment", () => $573299036e20ed65$export$9bfc1b16b4d8b950);

var $5uXOq = parcelRequire("5uXOq");

var $eXrJi = parcelRequire("eXrJi");

var $joX8T = parcelRequire("joX8T");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $8zOmE = parcelRequire("8zOmE");
var $d22NM = parcelRequire("d22NM");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $cNd4s = parcelRequire("cNd4s");

const $573299036e20ed65$export$9bfc1b16b4d8b950 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $d22NM.useAnalyticsEvents)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const { isOrgAdmin: isOrgAdmin } = (0, $eXrJi.useIsOrgAdmin)();
    const appEditions = (0, $k9JTq.useAppEditions)();
    /**
	 * Returns true when the kill switch is enabled, the tenant is on a free edition, and a user is not an admin (end user).
	 * This determines if any other experiment code is executed.
	 */ const experimentIsEnabled = (0, $5uXOq.useMemo)(()=>{
        if (!(0, $4R6GH.fg)('end_user_xflow_via_e2e_killswitch')) return false;
        if (appEditions.software !== (0, $ldyPw.FREE_EDITION)) return false;
        if (isSiteAdmin || isOrgAdmin) return false;
        return true;
    }, [
        appEditions,
        isSiteAdmin,
        isOrgAdmin
    ]);
    /**
	 * Determine the experiment cohort. If the experimentIsEnabled is false, this always returns NOT_ENROLLED.
	 */ const getExperimentCohort = (0, $5uXOq.useCallback)(()=>{
        if (experimentIsEnabled) return (0, $6s1PB.expVal)('issue_view_end_users_cross-flow_via_e2e_flow', 'cohort', 'not-enrolled');
        return 0, $joX8T.NOT_ENROLLED;
    }, [
        experimentIsEnabled
    ]);
    /**
	 * Determine if the user is enrolled in the experiment. If the experimentIsEnabled is false, this always returns false
	 */ const isEnrolledInExperiment = (0, $5uXOq.useCallback)(()=>{
        if (experimentIsEnabled) return getExperimentCohort() !== (0, $joX8T.NOT_ENROLLED);
        return false;
    }, [
        experimentIsEnabled,
        getExperimentCohort
    ]);
    /**
	 * Conditionally fire the exposure event. If the user is not enrolled in this experiment, this is a no-op.
	 */ const fireExposureEvent = (0, $5uXOq.useCallback)(()=>{
        if (isEnrolledInExperiment()) {
            const cohort = getExperimentCohort();
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $bef077ad6d5f9011$export$aeea431ee25af4e3)} exposed`, {
                experiment: (0, $bef077ad6d5f9011$export$b4a40e565a132963),
                cohort: cohort
            });
        }
    }, [
        isEnrolledInExperiment,
        createAnalyticsEvent,
        getExperimentCohort
    ]);
    /**
	 * Returns true when the cohort is variation.
	 */ const isVariation = (0, $5uXOq.useCallback)(()=>getExperimentCohort() === (0, $joX8T.VARIATION), [
        getExperimentCohort
    ]);
    return {
        experimentIsEnabled: experimentIsEnabled,
        isEnrolledInExperiment: isEnrolledInExperiment,
        fireExposureEvent: fireExposureEvent,
        getExperimentCohort: getExperimentCohort,
        isVariation: isVariation
    };
};

});
parcelRegister("eXrJi", function(module, exports) {

$parcel$export(module.exports, "useIsOrgAdmin", () => $1b04ea73291e11e0$export$8ed42372757d8b2a);

var $5uXOq = parcelRequire("5uXOq");

var $ld2hZ = parcelRequire("ld2hZ");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $14XJw = parcelRequire("14XJw");

var $90yGq = parcelRequire("90yGq");
const $1b04ea73291e11e0$var$getUserOrgPermissions = async ({ orgId: orgId, userId: userId })=>(0, $eusud.performPostRequest)('/gateway/api/permissions/permitted', {
        body: JSON.stringify({
            resourceId: `ari:cloud:platform::org/${orgId}`,
            principalId: `ari:cloud:identity::user/${userId}`,
            permissionId: 'manage-users'
        })
    }).then((resp)=>!!resp?.permitted);
const $1b04ea73291e11e0$export$8ed42372757d8b2a = ()=>{
    const userId = (0, $90yGq.useAccountId)();
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const checkUserIsOrgAdmin = (0, $5uXOq.useCallback)(async ()=>{
        if (!userId || !orgId) return false;
        return $1b04ea73291e11e0$var$getUserOrgPermissions({
            orgId: orgId,
            userId: userId
        });
    }, [
        orgId,
        userId
    ]);
    const { loading: loading, error: error, data: data, fetch: fetchIsOrgAdmin } = (0, $ld2hZ.useService)(checkUserIsOrgAdmin, {
        data: false
    });
    (0, $5uXOq.useEffect)(()=>{
        fetchIsOrgAdmin();
    }, [
        fetchIsOrgAdmin
    ]);
    (0, $5uXOq.useEffect)(()=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'checkUserIsOrgAdmin',
                packageName: 'jiraBusinessGoalPicker',
                teamName: 'jira-yurree'
            },
            sendToPrivacyUnsafeSplunk: true,
            error: error
        });
    }, [
        error
    ]);
    return {
        isOrgAdmin: !!data,
        loading: loading,
        hasErrorOccurred: !!error,
        retry: fetchIsOrgAdmin
    };
};

});

parcelRegister("joX8T", function(module, exports) {

$parcel$export(module.exports, "COHORT", () => $a85d1363752adaec$export$3d370c33621572df);
$parcel$export(module.exports, "NOT_ENROLLED", () => $a85d1363752adaec$export$5b7423264d48ab04);
$parcel$export(module.exports, "CONTROL", () => $a85d1363752adaec$export$43f367b3e957f219);
$parcel$export(module.exports, "VARIATION", () => $a85d1363752adaec$export$fa04ad826acc90da);

var $co1wz = parcelRequire("co1wz");
const $a85d1363752adaec$export$3d370c33621572df = 'cohort';
const $a85d1363752adaec$export$5b7423264d48ab04 = 'not-enrolled';
const $a85d1363752adaec$export$43f367b3e957f219 = 'control';
const $a85d1363752adaec$export$9ba2bc3b1bdc1519 = 'experiment';
const $a85d1363752adaec$export$fa04ad826acc90da = 'variation';
const $a85d1363752adaec$export$6486974e39493fa6 = 'variation-1';
const $a85d1363752adaec$export$7d994996134ad562 = 'variation-2';
const $a85d1363752adaec$export$795e7d69b248dcd0 = 'variation-3';
const $a85d1363752adaec$export$c9c947c57470b787 = 'variation-4';
const $a85d1363752adaec$var$DEFAULT_VALID_EXPERIMENT_GROUPS = [
    $a85d1363752adaec$export$5b7423264d48ab04,
    $a85d1363752adaec$export$43f367b3e957f219,
    $a85d1363752adaec$export$9ba2bc3b1bdc1519,
    $a85d1363752adaec$export$fa04ad826acc90da,
    $a85d1363752adaec$export$6486974e39493fa6,
    $a85d1363752adaec$export$7d994996134ad562,
    $a85d1363752adaec$export$795e7d69b248dcd0,
    $a85d1363752adaec$export$c9c947c57470b787
];
var // Use optionalValidExperimentGroups to further restrict the list of cohorts
// eslint-disable-next-line jira/import/no-anonymous-default-export
$a85d1363752adaec$export$2e2bcd8739ae039 = (experimentFeatureFlag, validExperimentGroups = $a85d1363752adaec$var$DEFAULT_VALID_EXPERIMENT_GROUPS)=>(0, $co1wz.getMultivariateFeatureFlag)(experimentFeatureFlag, $a85d1363752adaec$export$5b7423264d48ab04, validExperimentGroups);

});

const $bef077ad6d5f9011$export$aeea431ee25af4e3 = 'issueViewEndUsersCrossFlowViaE2EExperiment';
const $bef077ad6d5f9011$export$b4a40e565a132963 = 'issue_view_end_users_cross-flow_via_e2e_flow';


parcelRegister("j1hWq", function(module, exports) {

$parcel$export(module.exports, "InfoIconWithPopup", () => $debde6c5e24d67f7$export$cd44263135848517);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $2VAS6 = parcelRequire("2VAS6");

var $gqw9P = parcelRequire("gqw9P");

var $gwIPs = parcelRequire("gwIPs");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $d22NM = parcelRequire("d22NM");

var $3K0KG = parcelRequire("3K0KG");

var $3sqIb = parcelRequire("3sqIb");
const $debde6c5e24d67f7$export$cd44263135848517 = /*#__PURE__*/ (0, $5uXOq.memo)(()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $d22NM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (isOpen) (0, $8zOmE.fireScreenAnalytics)(createAnalyticsEvent({}));
    }, [
        isOpen,
        createAnalyticsEvent
    ]);
    const clickedIconBaseEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'icon'
    });
    const onClickIcon = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(!isOpen);
        (0, $8zOmE.fireUIAnalytics)(clickedIconBaseEvent, 'descriptionTemplatesInfoIcon');
    }, [
        isOpen,
        clickedIconBaseEvent
    ]);
    return /*#__PURE__*/ $5uXOq.createElement((0, $gqw9P.default), {
        zIndex: (0, $gwIPs.layers).modal,
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ $5uXOq.createElement("div", {
                className: (0, $bwpsq.default)([
                    "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _1bsbclpc"
                ])
            }, formatMessage((0, $3K0KG.default).popupTextUpdated)),
        trigger: (triggerProps)=>/*#__PURE__*/ $5uXOq.createElement((0, $3sqIb.InfoButton), {
                ...triggerProps,
                appearance: "subtle",
                isSelected: isOpen,
                onClick: onClickIcon,
                iconBefore: /*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($2VAS6))), {
                    label: "Info",
                    LEGACY_size: "medium",
                    color: isOpen ? "var(--ds-text-selected, #0C66E4)" : "var(--ds-icon, #44546F)"
                })
            })
    });
});
const $debde6c5e24d67f7$var$contentStyles = null;

});



//# sourceMappingURL=async-dummy-confluence-link-view.af49f7ef.js.map
